import PropTypes from 'prop-types';

import './ModuleContainer.scss';

const ModuleContainer = ({ children, highlighted }) => (
  <section className={highlighted ? 'module-container--highlighted' : ''}>
    <div className="module-container">{children}</div>
  </section>
);

ModuleContainer.propTypes = {
  highlighted: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ]).isRequired
};

ModuleContainer.defaultProps = {
  highlighted: false
};

export default ModuleContainer;
